import React from "react";
import { useNavigate } from "react-router-dom";
import useLayouts from "../../layouts";

const Forbidden = () => {
  const { PrivateContentLayout } = useLayouts();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <PrivateContentLayout title="Acceso Denegado">
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
        <div className="text-center max-w-md">
          {/* Icon */}
          <div className="mb-6">
            <svg
              className="mx-auto h-24 w-24 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Acceso Denegado
          </h1>

          {/* Description */}
          <p className="text-lg text-gray-600 mb-8">
            No tienes permisos para acceder a este módulo. Por favor, contacta con tu administrador si crees que esto es un error.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleGoBack}
              className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors"
            >
              Volver
            </button>
            <button
              onClick={handleGoToDashboard}
              className="px-6 py-3 bg-black text-[#ffb62a] rounded-lg font-medium hover:bg-primary-600 transition-colors"
            >
              Ir al Dashboard
            </button>
          </div>
        </div>
      </div>
    </PrivateContentLayout>
  );
};

export default Forbidden;
